<template>
  <div class="object-search-form_osf" :class="{ [curTheme]: true }">

    <div class="form-wrap_fwp">
      <div class="fwp_form-container">

        <div class="fwp_site-title">
          Цифровая платформа<br>обмена знаниями и управления авторскими правами
        </div>

        <div class="primary-inputs_pis" @keyup.enter="submit">

          <div class="pis_query-input">
            <app-input
              widget="AppSearchQuery"
              v-model="form.q"/>
            <i class="pis_search-btn el-icon-search" @click="submit"></i>
            <div class="pis_query-line"></div>
          </div>

          <div class="filters-cols_fcs">
            <div class="fcs_col">
              <app-input
                class="fcs_types"
                widget="AppType"
                @change="onTypeChange"
                :options="{ title: 'Тип объекта:', placeholder: getTypePlaceholder(),
                  showIcon: false }"
                v-model="form.type"/>
            </div>
            <div class="fcs_col">
              <app-input
                class="fcs_orgs"
                widget="AppOrganization"
                @change="onOrganizationChange"
                :options="{ title: 'Университет:', placeholder: getOrgPlaceholder() }"
                v-model="form.organization"/>
            </div>
            <div class="fcs_col-sm">
              <button class="adv-trigger" @click="isAdvVisible = !isAdvVisible">
                <i class="el-icon-more"></i>
              </button>
            </div>
          </div>
        </div>

        <theme-selector
          class="fwp_theme-selector tsr--pure-colors"/>

      </div>
    </div>

    <transition name="popup-fade">
    <div class="adv-popup_app" v-if="isAdvVisible" @keyup.enter="submit">

      <div class="app_header">
        Расширенный поиск
        <button @click="isAdvVisible = false" class="app_close">
          <i class="el-icon-close"></i></button>
      </div>
      <router-link
        class="help-link"
        :to="{ path: '/help/11'}"
        target="_blank">
        Подробнее о поиске в разделе Помощь
      </router-link>

      <div class="app_cols">

        <div class="app_col">

        <app-input
          widget="AppText"
          :options="{ title: 'Авторы',
            singleLine: true, placeholder: 'Введите Ф.И.О...' }"
          v-model="form.author"/>

        <app-input
          widget="AppText"
          :options="{ title: 'Искать в заглавии', singleLine: true,
            placeholder: 'Введите фразу...' }"
          v-model="form.title"/>

        <app-input
          widget="AppText"
          :options="{ title: 'Искать в аннотации', singleLine: true,
            placeholder: 'Введите фразу...' }"
          v-model="form.annotation"/>

          <app-input
            widget="AppSelect"
            v-if="!isMobile"
            :options="{ title: 'Страна', vocabulary: 'countries' }"
            v-model="form.country"/>

          <app-input
            widget="AppSearchDates"
            v-if="!isMobile"
            :options="{ title: 'Дата депонирования' }"
            v-model="form.dates"/>

        </div>
        <div class="app_col">

        <app-input
          widget="AppSelect"
          :options="{ title: 'Типовой смарт-контракт', options: licensesForSelect }"
          v-model="form.license"/>

        <app-input
          widget="AppSelect"
          v-if="!isMobile"
          :options="{ title: 'Идентификатор УДК', vocabulary: 'UDC' }"
          v-model="form.udc"/>

        <app-input
          widget="AppSelect"
          v-if="!isMobile"
          :options="{ title: 'Идентификатор ОКВЭД', vocabulary: 'RCEA' }"
          v-model="form.rcea"/>

        <!--<app-input
          widget="AppSearchDates"
          :options="{ title: 'Дата депонирования' }"/>-->

        <app-input
          widget="AppText"
          :options="{ title: 'Ключевое слово',
          placeholder: 'Введите значение...', singleLine: true }"
          v-model="form.keyword"/>

        <app-input
          widget="AppSelect"
          :options="{ title: 'Есть файлы предпросмотра',
            options: { false: 'Нет', true: 'Да' } }"
          v-model="form.existPreview"/>

        </div>
      </div>

      <div class="app_btns">
        <button @click="submit" class="app_btn app_btn--search">
          <i class="el-icon-search"></i> Искать</button>
        <button @click="clearAdvForm" class="app_btn app_btn--clear">
          <i class="el-icon-delete"></i> Очистить</button>
      </div>

    </div>
    </transition>

  </div>
</template>

<script>
/* eslint-disable object-shorthand, no-useless-computed-key */
import axios from 'axios';
import AppInput from './inputs/AppInput';
import ThemeSelector from './ThemeSelector';
import licenses from '../data/licenses';

export default {

  components: { AppInput, ThemeSelector },

  data() {
    return {
      form: {
        q: [],
        type: [],
        organization: [],
        author: [],
        title: [],
        annotation: [],
        keyword: [],
        country: [],
        license: [],
        udc: [],
        rcea: [],
        dates: [],
        existPreview: [],
      },
      advancedActive: false,
      isAdvVisible: false,
      licenses,
      secsInDay: 86399,
    };
  },

  watch: {

    $route() {
      this.isAdvVisible = false;
      this.fetchFormData();
    },

  },

  created() {
    this.fetchFormData();
  },

  computed: {

    licensesForSelect() {
      const ls = {};
      Object.keys(this.licenses).forEach((key) => {
        ls[key] = this.licenses[key].Title;
      });
      return ls;
    },

  },

  methods: {

    clearAdvForm() {
      Object.keys(this.form).forEach((fieldName) => {
        if (['q', 'type', 'organization'].indexOf(fieldName) > -1) return;
        this.form[fieldName][0] = '';
        this.form[fieldName].push('');
        this.form[fieldName].pop();
      });
    },

    getTypePlaceholder() {
      return window.innerWidth < 1000 ? 'Выберите...' : 'Выберите тип объекта...';
    },

    getOrgPlaceholder() {
      return window.innerWidth < 1000 ? 'Выберите...' : 'Выберите организацию...';
    },

    fetchFormData() {
      Object.keys(this.form).forEach((fieldId) => {
        if (typeof this.$route.query[fieldId] !== 'undefined') {
          if (fieldId === 'dates') {
            const dates = this.$route.query[fieldId].split('--');
            this.form[fieldId][0] = [dates[0], dates[1]];
          } else {
            this.form[fieldId][0] = this.$route.query[fieldId];
          }
        } else {
          this.form[fieldId][0] = '';
        }
        if (fieldId === 'dates'
          && typeof this.$route.query.dateStart !== 'undefined'
          && typeof this.$route.query.dateEnd !== 'undefined'
        ) {
          const sDate = new Date(this.$route.query.dateStart * 1000);
          const eDate = new Date((this.$route.query.dateEnd - this.secsInDay) * 1000);
          const start = [sDate.getFullYear(), sDate.getMonth() + 1, sDate.getDate()].join('-');
          const end = [eDate.getFullYear(), eDate.getMonth() + 1, eDate.getDate()].join('-');
          this.form.dates[0] = `${start}по${end}`;
        }
        this.form[fieldId].push('');
        this.form[fieldId].pop();
      });
    },

    submit() {
      if (this.form.q[0] && this.form.q[0].match(/^IPC-[A-Za-z0-9._-]+$/)) {
        axios.get(`/objects/${this.form.q[0]}`).then(() => {
          this.$router.push({ path: `/object/${this.form.q[0]}` });
        }).catch(() => {
          this.initSearch();
        });
      } else {
        this.initSearch();
      }
    },

    initSearch() {
      const query = {};
      Object.keys(this.form).forEach((fieldName) => {
        const f = this.form;
        if (f[fieldName][0]) {
          if (fieldName === 'dates') {
            query.dateStart = (new Date(f[fieldName][0][0])).getTime() / 1000;
            query.dateEnd = (new Date(f[fieldName][0][1])).getTime() / 1000;
            query.dateEnd += this.secsInDay;
          } else {
            query[fieldName] = f[fieldName][0];
          }
        }
      });
      this.$router.push({ path: '/objects/search', query });
    },

    onTypeChange() {
      this.submit();
    },

    onOrganizationChange() {
      this.submit();
    },

  },

};
</script>

<style lang="scss">
@import "../styles/common/main";

body.is-mobile {
  .object-search-form_osf .adv-popup_app {
    width: 756px;
    @media (max-width: 800px) {
      width: auto;
    }
  }
}

.object-search-form_osf {

  .form-wrap_fwp {
    padding: 40px 25px 30px;
    @include clearfix;
    @extend .grad;
    @media (max-width: 600px) {
      padding: 30px 15px;
    }

    .fwp_form-container {
      max-width: 1790px;
      margin: 0 auto;
      position: relative;
      text-align: center;
    }

    .fwp_site-title {
      text-align: left;
      color: #fff;
      font-weight: 300;
      font-size: 19px;
      line-height: 32px;
      position: absolute;
      left: 0;
      top: 0;
      max-width: 300px;
      opacity: .5;
      @media (max-width: 1400px) {
        max-width: 220px;
        line-height: 24px;
      }
      @media (max-width: 1270px) {
        display: none;
      }
    }
    .fwp_theme-selector {
      position: absolute;
      top: 0;
      right: 40px;
      @media (max-width: 1270px) {
        display: none;
      }
    }
  }

  .primary-inputs_pis {
    max-width: 750px;
    width: 100%;
    display: inline-block;
    .pis_query-input {
      margin-bottom: 20px;
      padding: 0 30px;
      position: relative;
      @media (max-width: 1000px) {
        padding: 0 25px;
      }
      @media (max-width: 700px) {
        padding: 0 20px;
      }
      @media (max-width: 400px) {
        padding: 0 15px;
      }
      .pis_search-btn {
        position: absolute;
        right: 0;
        top: 2px;
        font-size: 30px;
        color: #fff;
        opacity: .4;
        cursor: pointer;
        @include transition;
        &:hover {
          opacity: .8;
        }
        @media (max-width: 1000px) {
          top: 3px;
          font-size: 28px;
        }
        @media (max-width: 700px) {
          top: 4px;
          font-size: 24px;
        }
        @media (max-width: 400px) {
          top: 6px;
          font-size: 21px;
        }
      }
      .app-input_ait {
        padding-bottom: 12px;
      }
      .el-input__inner {
        text-align: center;
        font-size: 29px;
        background: transparent;
        @include box-shadow(none);
        font-weight: 300;
        @media (max-width: 1000px) {
          font-size: 24px;
        }
        @media (max-width: 700px) {
          font-size: 21px;
        }
        @media (max-width: 400px) {
          font-size: 17px;
        }
      }
      .pis_query-line {
        height: 1px;
        background: -moz-linear-gradient(left, rgba(255,255,255,0) 0%,
          rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%);
        background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,
          rgba(255,255,255,1) 50%,rgba(255,255,255,0) 100%);
        background: linear-gradient(to right, rgba(255,255,255,0) 0%,
          rgba(255,255,255,1) 50%,rgba(255,255,255,0) 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00ffffff',
          endColorstr='#00ffffff',GradientType=1 );
      }
    }
  }

  .filters-cols_fcs {
    @include clearfix;
    .fcs_col {
      float: left;
      width: 47%;
      @include clearfix;
      .input-title {
        float: left;
        opacity: .9;
        font-weight: 300;
        font-size: 16px;
      }
      .input-groups {
        float: left;
        width: 245px;
        margin-left: 0;
        margin-top: -18px;
      }
      .el-select__caret {
        color: #fff !important;
        @include transition;
        &:hover {
          opacity: .6;
        }
      }
      .el-input__inner {
        background: transparent;
        @include box-shadow(none);
        &::-webkit-input-placeholder {
          color: #fff !important;
          opacity: 1;
          font-weight: 300;
        }
        &:-ms-input-placeholder {
          color: #fff !important;
          opacity: 1;
          font-weight: 300;
        }
        &::-moz-placeholder {
          color: #fff !important;
          opacity: 1;
          font-weight: 300;
        }
        &:-moz-placeholder {
          color: #fff !important;
          opacity: 1;
          font-weight: 300;
        }
      }
      .fcs_types {
        padding-right: 5px;
      }
      .fcs_orgs {
        padding-left: 5px;
      }
      @media (max-width: 810px) {
        width: 100%;
        float: none;
        text-align: center;
        height: 35px;
        .app-input_ait {
          display: inline-block;
        }
        .input-groups {
          width: 180px;
        }
        .fcs_types {
          padding-left: 10px;
        }
        .fcs_orgs {
          padding-left: 0;
        }
      }
    }
    .fcs_col-sm {
      float: left;
      width: 6%;
      .adv-trigger {
        cursor: pointer;
        i {
          font-size: 22px;
          color: #fff;
        }
      }
      @media (max-width: 810px) {
        width: 100%;
        float: none;
      }
    }
  }

  .adv-popup_app {
    background: #fff;
    position: absolute;
    max-width: 800px;
    left: 50%;
    margin-left: -385px;
    @include border-radius(12px);
    padding: 0 30px;
    overflow: hidden;
    z-index: 20;
    @include box-shadow(0 2px 20px rgba(0, 0, 0, .2));
    @media (max-width: 830px) {
      margin: 0;
      left: 15px;
      right: 15px;
    }
    .app_cols {
      margin: 0 -13px;
      @include clearfix;
      .app_col {
        width: 50%;
        padding: 0 15px 20px;
        margin: 0;
        float: left;
        .input-title {
          color: #333;
          text-align: left;
          padding-bottom: 5px;
          font-size: 15px;
        }
        .el-range__close-icon,
        .el-select__caret {
          @include transition;
          color: #000 !important;
          opacity: .5;
          &:hover {
            opacity: .8;
          }
        }
        .el-range-separator {
          color: #333 !important;
        }
        .el-input__inner {
          background: rgba(0, 0, 0, .05);
          color: #333;
        }
        .el-range-input,
        .el-input__inner {
          color: #000 !important;
          &::-webkit-input-placeholder {
            font-family: $font;
            font-weight: 300;
            font-size: 16px;
            color: #aaa !important;
            opacity: 1;
          }
          &:-ms-input-placeholder {
            font-family: $font;
            font-weight: 300;
            font-size: 16px;
            color: #aaa !important;
            opacity: 1;
          }
          &::-moz-placeholder {
            font-family: $font;
            font-weight: 300;
            font-size: 16px;
            color: #aaa !important;
            opacity: 1;
          }
          &:-moz-placeholder {
            font-family: $font;
            font-weight: 300;
            font-size: 16px;
            color: #aaa !important;
            opacity: 1;
          }
          &::selection {
            background: #706bb0;
            color: #fff;
          }
          &::-moz-selection {
            background: #706bb0;
            color: #fff;
          }
        }
      }
      @media (max-width: 760px) {
        .app_col {
          width: 100%;
          float: none;
          padding: 0;
          .app-input_ait {
            padding: 0 0 15px;
          }
        }
      }
    }
    .app_header {
      margin: 0 -30px 0;
      padding: 35px 25px 25px;
      text-align: center;
      text-transform: uppercase;
      font-weight: 400;
      position: relative;
      color: lighten($color-1, 5%);
      .app_close {
        position: absolute;
        right: 20px;
        top: 16px;
        color: #000;
        font-size: 28px;
        opacity: .5;
        @include transition;
        cursor: pointer;
        &:hover {
          opacity: 1;
        }
      }
      @media (max-width: 800px) {
        text-align: left;
      }
    }
    .app_btns {
      margin: 0 -30px;
      text-align: center;
      padding: 10px 0 30px;
      .app_btn {
        margin: 10px;
        width: 150px;
        display: inline-block;
        text-align: center;
        @include border-radius;
        cursor: pointer;
        line-height: 0;
        font-weight: 300;
        color: #333;
        font-size: 15px;
        border: 1px solid #bbb;
        padding: 10px 0;
        @include transition;
        &:hover {
          color: #fff;
          background: #bbb;
          border-color: transparent !important;
        }
        &.app_btn--search {
          border-color: #da5486;
          color: #da5486;
          &:hover {
            color: #fff;
            @extend .grad;
          }
        }
      }
    }
  }
  .popup-fade-enter-active, .popup-fade-leave-active {
    transition: all .5s;
    @include transform(translateY(0));
  }
  .popup-fade-enter, .popup-fade-leave-to {
    opacity: 0;
    @include transform(translateY(-30px));
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ObjectSearchForm.vue